import React, {useState} from "react";
import "../FastPrint/fastprint.scss";
import Modal, {ModalBody, ModalHeader} from "../Modal";
import _axios from "../../httpService";
import {toast} from "react-toastify";
import {Link, useNavigate} from "react-router-dom";
import ModalSelectProduct from "../CardexProduct/ModalSelectProduct/ModalSelectProduct";
import {prefixUrl} from "../../utils/utilsData";

const Cardex = () => {

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [dataFromModal, setDataFromModal] = useState({
    column: [],
    data: [],
    overallReport: {},
    name: "انتخاب کالا",
    id: "",
  })
  const [anbarFilter, setAnbarFilter] = useState({enable: false, id: ""});
  const [dateFilter, setDateFilter] = useState({enable: false, startDate: "", endDate: ""})
  const [productId, setProductId] = useState("");
  const navigateTo = useNavigate()

  const addDataModalHandler = (inventoryId) => {

    _axios.get(prefixUrl() + "/cardex/?request=productCardex&productId=" + inventoryId?.productId + "&storeFilter=" + JSON.stringify(anbarFilter) + "&dateFilter=" + JSON.stringify(dateFilter))
      .then((response) => {
        if (response.data.status) {
          response.data.column.push({
            field: "edit",
            title: "ویرایش",
            headerFilter: true,
          });
          setProductId(inventoryId?.productId)
          setDataFromModal(response.data);
          setIsOpenModal(false);
        } else {
          toast.error(response.data.message);
        }
      });
  };

  const showAllProductData = () => {
    _axios.get(prefixUrl() + "/cardex/?request=productCardex&productId=all" + "&storeFilter=" + JSON.stringify(anbarFilter) + "&dateFilter=" + JSON.stringify(dateFilter))
      .then((response) => {
        if (response.data.status) {
          navigateTo("/cardexProduct", {state: {CardexData: response.data, productId: "all"}})
        } else {
          toast.error(response.data.message);
        }
      });
  }
  return (
    <>
      <Modal
        isOpen={isOpenModal}
        modalCallback={() => setIsOpenModal(false)}
        widthProp={1000}>
        <ModalHeader title={"انتخاب کالا"}/>

        <ModalBody>
          <>
            <div
              className={""}
              style={{
                padding: "5px",
                overflow: "scroll",
                margin: "auto",
                width: "900px",
              }}>
              <ModalSelectProduct
                addHandler={addDataModalHandler}
                closeModal={() => setIsOpenModal(false)}
              />
            </div>
          </>
        </ModalBody>
      </Modal>

      <button className="kala-select" onClick={() => setIsOpenModal(true)}>
        {dataFromModal.id !== ""
          ? dataFromModal.id +
          " / " +
          dataFromModal.name
          : dataFromModal.name}
      </button>

      <div className="text-center mt-3">
        {dataFromModal.id === "" ? (
          <button className="btnCustom btnSubmit" onClick={showAllProductData}>
            مشاهده کاردکس کالا
          </button>
        ) : (
          <Link to={"/cardexProduct"} state={{CardexData: dataFromModal, productId: productId}}>
            <button className="btnCustom btnSubmit">مشاهده کاردکس کالا</button>
          </Link>
        )}
      </div>
    </>
  );
};
export default Cardex;
